/*
 * Rowdy: policy pages. Turns long legal text into something easier to read:
 * - Shopify's own /policies pages get the same layout as our "legal" page template
 * - headings tidied (no shouting capitals), clause numbers styled
 * - an "On this page" list built from the headings, with the current section highlighted
 * - reading time, a thin reading-progress line, links to the other policies and a "Questions?" card
 */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function sentenceCase(str) {
    var t = str.trim();
    if (t.length < 3 || t !== t.toUpperCase() || !/[A-Z]/.test(t)) return null;
    t = t.toLowerCase();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function slug(str, used) {
    var base = str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    var s = base, n = 2;
    while (used[s] || document.getElementById(s)) { s = base + '-' + n++; }
    used[s] = true;
    return s;
  }

  // Shopify's /policies pages: rebuild into the same structure as the page template
  function buildFromPolicy() {
    var box = document.querySelector('.shopify-policy__container');
    if (!box || document.querySelector('[data-rlg]')) return null;
    var titleEl = box.querySelector('.shopify-policy__title h1, .shopify-policy__title');
    var bodyEl = box.querySelector('.shopify-policy__body') || box;
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var root = document.createElement('div');
    root.className = 'rlg rlg--policy';
    root.setAttribute('data-rlg', '');
    root.innerHTML =
      '<header class="rlg__band"><div class="page-width rlg__band-inner">' +
      '<p class="rlg__eyebrow">Policies</p><h1 class="rlg__title"></h1>' +
      '<p class="rlg__meta"><span data-rlg-read hidden></span></p><div data-rlg-nav-slot></div></div></header>' +
      '<div class="page-width rlg__grid"><aside class="rlg__toc" data-rlg-toc hidden><details class="rlg__toc-box" open><summary>On this page</summary>' +
      '<ol class="list-unstyled" role="list" data-rlg-toc-list></ol></details></aside>' +
      '<article class="rlg__body rte" data-rlg-body></article></div><div class="page-width" data-rlg-help-slot></div>';
    root.querySelector('.rlg__title').textContent = sentenceCase(title) || title;
    var article = root.querySelector('[data-rlg-body]');
    while (bodyEl.firstChild) article.appendChild(bodyEl.firstChild);
    box.parentNode.replaceChild(root, box);
    document.body.classList.add('rlg-page');
    return root;
  }

  function tidy(body) {
    // Shopify wraps policy text in a <div class="rte">: unwrap it so the text sits directly in the article
    var wrap = body.children.length === 1 && body.firstElementChild.tagName === 'DIV' ? body.firstElementChild : null;
    if (wrap) { while (wrap.firstChild) body.insertBefore(wrap.firstChild, wrap); wrap.remove(); }
    // Stray line breaks between blocks
    Array.prototype.slice.call(body.children).forEach(function (el) { if (el.tagName === 'BR') el.remove(); });
    // One paragraph made of several, split by blank lines: make them real paragraphs
    body.querySelectorAll('p').forEach(function (p) {
      if (!/<br\s*\/?>\s*(&nbsp;|\s)*<br\s*\/?>/i.test(p.innerHTML)) return;
      p.innerHTML.split(/<br\s*\/?>\s*(?:&nbsp;|\s)*<br\s*\/?>/i).forEach(function (html) {
        var np = document.createElement('p'); np.innerHTML = html.trim(); p.parentNode.insertBefore(np, p);
      });
      p.remove();
    });
    // "<p><strong>Heading</strong><br>Text</p>": a heading followed by its paragraph
    body.querySelectorAll('p').forEach(function (p) {
      var first = p.firstChild;
      while (first && first.nodeType === 3 && !first.nodeValue.trim()) first = first.nextSibling;
      if (!first || first.nodeType !== 1 || !/^(STRONG|B)$/.test(first.tagName)) return;
      var next = first.nextSibling;
      while (next && next.nodeType === 3 && !next.nodeValue.trim()) next = next.nextSibling;
      if (!next || next.nodeName !== 'BR') return;
      var txt = first.textContent.trim();
      if (!txt || txt.length > 70 || /^\d+(\.\d+)*\.?$/.test(txt)) return;
      var h = document.createElement('h3');
      h.textContent = txt;
      p.parentNode.insertBefore(h, p);
      first.remove(); next.remove();
    });
    // Empty paragraphs and spacer breaks left by the admin editor
    body.querySelectorAll('p').forEach(function (p) {
      if (!p.textContent.replace(/ /g, ' ').trim() && !p.querySelector('img, iframe')) p.remove();
    });
    // Headings: no bold-inside-bold, no shouting capitals
    body.querySelectorAll('h1, h2, h3, h4, h5').forEach(function (h) {
      h.querySelectorAll('strong, b').forEach(function (s) { s.replaceWith(document.createTextNode(s.textContent)); });
      var sc = sentenceCase(h.textContent);
      if (sc) h.textContent = sc;
    });
    // A paragraph that is only bold text acts as a heading in some policies: treat it as one
    body.querySelectorAll('p').forEach(function (p) {
      var only = p.children.length === 1 && /^(STRONG|B)$/.test(p.children[0].tagName) && p.textContent.trim() === p.children[0].textContent.trim();
      var txt = p.textContent.trim();
      if (only && txt.length < 70 && !/^\d+(\.\d+)*\.?$/.test(txt)) {
        var h = document.createElement('h3');
        h.textContent = sentenceCase(txt) || txt;
        p.replaceWith(h);
      }
    });
    // Brand name: "Rowdy", never "ROWDY"
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT), node;
    while ((node = walker.nextNode())) {
      if (/\bROWDY\b/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\bROWDY\b/g, 'Rowdy');
    }
    // Clause numbers like "2.1." at the start of a paragraph
    body.querySelectorAll('p > strong:first-child, p > b:first-child').forEach(function (s) {
      if (/^\d+(\.\d+)*\.?$/.test(s.textContent.trim())) s.classList.add('rlg__clause');
    });
    // "At a glance" heading followed by a list: show the list as summary tiles (bold text = the big line)
    body.querySelectorAll('h2, h3, h4').forEach(function (h) {
      var list = h.nextElementSibling;
      if (!/^at a glance:?$/i.test(h.textContent.trim()) || !list || list.tagName !== 'UL') return;
      h.classList.add('rlg__glance-title');
      h.setAttribute('data-rlg-skip', '');
      list.classList.add('rlg__glance');
      list.setAttribute('role', 'list');
    });
    // Tables scroll on small screens
    body.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement.classList.contains('rlg__table')) return;
      var w = document.createElement('div'); w.className = 'rlg__table'; t.parentNode.insertBefore(w, t); w.appendChild(t);
    });
  }

  function toc(root, body) {
    var list = root.querySelector('[data-rlg-toc-list]');
    var aside = root.querySelector('[data-rlg-toc]');
    if (!list || !aside) return;
    var sel = function (tag) { return tag + ':not([data-rlg-skip])'; };
    var level = ['h2', 'h3', 'h4'].find(function (tag) { return body.querySelectorAll(sel(tag)).length >= 2; });
    if (!level) return;
    var heads = Array.prototype.slice.call(body.querySelectorAll(sel(level)));
    var used = {};
    heads.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    aside.hidden = false;
    root.classList.add('has-toc');
    // On phones the list starts closed
    if (window.matchMedia('(max-width: 989px)').matches) aside.querySelector('details').removeAttribute('open');
    list.addEventListener('click', function (e) {
      if (e.target.closest('a') && window.matchMedia('(max-width: 989px)').matches) aside.querySelector('details').removeAttribute('open');
    });
    if ('IntersectionObserver' in window) {
      var links = {};
      list.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            list.querySelectorAll('a.is-active').forEach(function (x) { x.classList.remove('is-active'); });
            var a = links[en.target.id]; if (a) a.classList.add('is-active');
          }
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  function extras(root) {
    var tpl = document.getElementById('RowdyLegalExtras');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    var nav = frag.querySelector('.rlg__nav'), help = frag.querySelector('.rlg__help');
    var navSlot = root.querySelector('[data-rlg-nav-slot]'), helpSlot = root.querySelector('[data-rlg-help-slot]');
    if (nav && navSlot) {
      nav.querySelectorAll('a').forEach(function (a) {
        var href = a.getAttribute('href').split('#')[0];
        if (href === location.pathname) a.setAttribute('aria-current', 'page');
      });
      navSlot.replaceWith(nav);
    }
    if (help && helpSlot) helpSlot.appendChild(help);
  }

  function readTime(root, body) {
    var el = root.querySelector('[data-rlg-read]');
    if (!el) return;
    var words = (body.textContent || '').trim().split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 220));
    el.textContent = mins + ' min read';
    el.hidden = false;
  }

  function progress(root) {
    var bar = document.createElement('div');
    bar.className = 'rlg__progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var body = root.querySelector('[data-rlg-body]');
    function update() {
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var done = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.2) / Math.max(total, 1)));
      bar.style.transform = 'scaleX(' + done + ')';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  ready(function () {
    var root = document.querySelector('[data-rlg]') || buildFromPolicy();
    if (!root) return;
    var body = root.querySelector('[data-rlg-body]');
    tidy(body);
    extras(root);
    toc(root, body);
    readTime(root, body);
    progress(root);
  });
})();
